import User from "./User";

export default class MassProduct
{
    public id: string = "";

    public productGroupId: string = "";

    public productType: string | null = null;

    public reportDefinitionId: string | null = null;

    public reportDefinitionName: string | null = null;

    public deleted: boolean = false;

    public deletedAt: Date | null = null;

    public deletedBy: User | null = null;

    public isMassProduct: boolean = true;
}